import { SupabaseClient } from "@supabase/supabase-js";
import { Database } from "../../supabase.types";
import { logException } from "@punchup/sentry";
import dayjs from "@punchup/utils/dayjs";

const PAGE_SIZE = 1000;

export async function fetchVerifiedComedians(
  supabase: SupabaseClient<Database>
): Promise<Map<string, { name: string; slug: string }>> {
  const result = new Map<string, { name: string; slug: string }>();
  const now = dayjs().toISOString();
  let offset = 0;

  while (true) {
    const { data, error } = await supabase
      .from("comedians")
      .select("id, display_name, slug")
      .eq("is_punchup_verified", true)
      .eq("is_external_preview", false)
      .lte("published_at", now)
      .range(offset, offset + PAGE_SIZE - 1);

    if (error) {
      logException(error, {
        data: "[comedian-weekly-digest] Failed to load verified comedians",
      });
      throw error;
    }

    if (!data || data.length === 0) break;

    for (const row of data) {
      result.set(row.id, { name: row.display_name, slug: row.slug });
    }

    offset += data.length;
    if (data.length < PAGE_SIZE) break;
  }

  return result;
}
